import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PayGateInitModel } from '../../models/payGate';
import { AppConfig } from './../../config/app-config';
import { FileSection, FileType } from './../../models/fileData';
import { EnquiriesService } from './../../services/enquiries.service';
import { TenderService } from './../../services/tender.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-process-payment',
  templateUrl: './process-payment.component.html'
})
export class ProcessPaymentComponent implements OnInit {

  private key = CryptoJS.enc.Utf8.parse('4512671236189784');
  private iv = CryptoJS.enc.Utf8.parse('4512671236189784');
  PaymentParams = '';
  successfulPayment: boolean = false
  paymentMessage = '';
  serverMessage = '';

  Tender$: any = {
    'id': 0,
    'title': '',
    'description': '',
    'websiteListingStartDate': null,
    'websiteListingEndDate': null,
  };

  TenderDocumentsList$: any[] = [];

  constructor(
    private tenderService: TenderService,
    private route: ActivatedRoute,
    protected sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private appConfig: AppConfig) {
  }

  ngOnInit() {
    //expected results ?successful=1&result_code=990017&additional=&docid=2029&checksum=8jD76ZkkGrP5bUwjTf0z8Q%3D%3D
  }

  ngAfterContentInit() {
    //this.loadTender();
    this.processPaymentResponse();
  }

  processPaymentResponse() {
    this.route.queryParams.subscribe((params) => {
      let successful = +params['successful'];

      let result_code = +params['result_code'];
      let additional = params['additional'];
      let docid = params['docid'];
      let checksum = params['checksum'];
      if (checksum != null)
        checksum = decodeURI(checksum);


      this.PaymentParams = "";
      this.PaymentParams += "<br />Success=" + successful;
      this.PaymentParams += "<br />result_code=" + result_code;
      this.PaymentParams += "<br />addtional=" + additional;
      this.PaymentParams += "<br />docid=" + docid;
      this.PaymentParams += "<br />checksum=" + checksum;

      this.PaymentParams += "<br />checksum decoded =" + this.decryptUsingAES256(checksum);

      if (successful == 1) {
        //todo: change this to load from decrypted value
        //decrypted checksum.split('|')
        this.loadTender(docid);
      }
      else {
        this.paymentMessage = this.getTransactionStatus(result_code);
        this.serverMessage += additional;
      }
    });
  }

  decryptUsingAES256(decString) {
    var decrypted = CryptoJS.AES.decrypt(decString, this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    console.log('Decrypted : ' + decrypted);
    console.log('utf8 = ' + decrypted.toString(CryptoJS.enc.Utf8));
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  loadTender(tenderId) {
    this.route.queryParams.subscribe((params) => {
      this.tenderService.getTenderArticle(tenderId).subscribe((response) => {
        this.Tender$ = response;
        this.Tender$.description = this.sanitizer.bypassSecurityTrustHtml(response.description);
        this.listDocuments(tenderId);
      }, (error) => {
        console.log(error);
      });
    });
  }

  listDocuments(tenderId: number) {
    this.tenderService.getFilesList(tenderId).subscribe((response) => {
      this.TenderDocumentsList$ = response as any[];
    }, (error) => {
      console.log(error);
    });
  }

  downloadDocument(documentId: number) {

    let linkedId = this.Tender$.id;

    var fileInfo = this.tenderService.getFileInfo(linkedId).subscribe((response) => {

      var fileInfo = response.find(x => x.id == documentId);

      fileInfo.fileLocation = this.appConfig.baseUrl + '/Uploads/' + FileSection[fileInfo.fileSection] + '/' + FileType[fileInfo.fileType] + '/' + fileInfo.linkedId + '/' + fileInfo.physicalFileName;

      this.tenderService.downloadFile(fileInfo.fileLocation).subscribe((fileResponse) => {

        // file-type
        let fileName = fileInfo.displayFileName;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(fileResponse.body);

        window.open(link.href, "_blank");

        //link.download = fileName;
        //link.click();
      }, (error) => {
        console.log(error);
      });

      return fileInfo;
    }, (error) => {
      console.log(error);
    });
  }

  getTransactionStatus(status: number) {
    let result = "";
    switch (status) {
      case 0:
        result = "N/A";
        break;
      case 990017:
      case 990030:
        result = "Thank you for your interest. Your transaction has been approved and you may download the tender documents below.";
        break;
      case 900003:
        result = "Thank you for your interest. Unfortunately you transaction has been declined due to insufficient funds.";
        break;
      case 900007:
        result = "Thank you for your interest. Unfortunately you transaction has been declined.";
        break;
      case 900004:
        result = "Thank you for your interest. Unfortunately you transaction has been declined due to an invalid card number.";
        break;
      case 990022:
        result = "Thank you for your interest. Unfortunately you transaction has been declined due to the transaction being unprocessed.";
        break;
    }
    return result;
  }

}
